import { getMedicareBase, parseMonthYear } from './studentMedicalValidation';

/**
 * The family Medicare card, read back from the answers a parent has already saved.
 *
 * The card number and expiry are not stored against the family — they are written onto each
 * child's record. On the way in they are derived from what TASS holds; on the way back nothing
 * derived them again, so returning to the screen showed the school's old number however many
 * times the parent had corrected it. Worse, the next save wrote that stale number back over
 * their own.
 *
 * This mirrors the derivation used for the TASS records so both paths agree: the number from the
 * first child who has one and is not on a temporary visa, and the latest expiry of any child.
 */
export const familyMedicareFromRecords = (records = []) => {
    const rows = Array.isArray(records) ? records : [];

    const withCard = rows.find((record) => record?.medicare_number
        && !record.istemporaryVisa
        && !record.temporary_visa);

    const expiries = rows.map((record) => record?.medicare_expiry).filter(Boolean);
    const latest = expiries.map(parseMonthYear).filter(Boolean).sort((a, b) => b - a)[0];

    const expiry = latest
        ? `${String(latest.getMonth() + 1).padStart(2, '0')}/${latest.getFullYear()}`
        : String(expiries[0] || '');

    return {
        number: withCard ? getMedicareBase(withCard.medicare_number) : '',
        expiry,
    };
};
